// extracted by mini-css-extract-plugin
module.exports = {"caret_prev_icon":"SeeAllVideosWithAudioDescription_caret_prev_icon__2jUlQ","video_audio_description":"SeeAllVideosWithAudioDescription_video_audio_description__3Uw36"};